import { useIntl } from 'react-intl';
import Select from '@rio-cloud/rio-uikit/Select';
import { ASSIGN_TO_OPTIONS, MOVE_TO_OPTIONS } from '../constants';
import { toSelectOptions } from '../../../../../../utils/aeg';
import { AegFormSectionProps, AegStatusEnum } from '../../../../../../models/newAEG';

const ForwardingSection = ({ values, errors, requiredFields, onChange }: AegFormSectionProps) => {
    const intl = useIntl();
    const requiredMessage = intl.formatMessage({ id: 'intl-msg:support.custom.fieldRequired' });
    const selectPlaceholder = intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.placeholder.select' });

    return (
        <section className='border rounded padding-15'>
            <h3 className='display-flex align-items-center gap-x-2 margin-top-0 margin-bottom-15 text-size-16 text-bold'>
                <span className='rounded-circle bg-primary text-color-white text-size-12 width-25 height-25 inline-flex items-center justify-center shrink-0'>
                    6
                </span>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.section.forwarding' })}
            </h3>
            <div className='grid grid-cols-[minmax(0,1fr)] sm:grid-cols-2 gap-x-4 gap-y-3'>
                <div className='form-group margin-bottom-0'>
                    <label htmlFor='aeg-move-to' className='text-size-12 text-medium text-color-dark'>
                        {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.field.moveTo' })}{' '}
                        {requiredFields.includes('moveTo') && <span className='text-color-danger'>*</span>}
                    </label>
                    <Select
                        id='aeg-move-to'
                        options={toSelectOptions(MOVE_TO_OPTIONS, intl)}
                        value={[values.moveTo]}
                        onChange={option => option && onChange('moveTo', option.id as AegStatusEnum)}
                    />
                    {errors.moveTo && <span className='text-size-12 text-color-danger'>{requiredMessage}</span>}
                </div>
                <div className='form-group margin-bottom-0'>
                    <label htmlFor='aeg-assign-to' className='text-size-12 text-medium text-color-dark'>
                        {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.field.assignTo' })}{' '}
                        {requiredFields.includes('assignTo') && <span className='text-color-danger'>*</span>}
                    </label>
                    <Select
                        id='aeg-assign-to'
                        options={toSelectOptions(ASSIGN_TO_OPTIONS, intl)}
                        value={values.assignTo ? [values.assignTo] : []}
                        onChange={option => onChange('assignTo', option?.id ?? '')}
                        placeholder={selectPlaceholder}
                    />
                    {errors.assignTo && <span className='text-size-12 text-color-danger'>{requiredMessage}</span>}
                </div>
            </div>
        </section>
    );
};

export default ForwardingSection;
